<template>
    <div id="list-ground-water-equipment-component" class="pa-4">
        <in-progress-component/>
    </div>
</template>

<script>
import InProgressComponent from "@/components/Error/InProgressComponent";

export default {
    name: "ListGroundWaterEquipmentComponent",
    components: {InProgressComponent}
}
</script>